export interface AgrupamentoResumo {
  id: string
  fontePagadoraId: string | null
  anoMesReferencia: string
  repassesQueSolicitamNF: boolean
  numeroChamado: string | null
}

export interface AgrupamentoRepasse {
  prestadorRecebimentoDocumentoId: string
  prestadorRecebimentoId: string
  numeroRepasse: string
  situacao: string
  situacaoRepasse: string
}

export interface MoverItemAgrupamentoSelecao {
  repasse: AgrupamentoRepasse | null
  agrupamento: AgrupamentoResumo | null
}

export interface MoverItemAgrupamentoRequest {
  prestadorRecebimentoDocumentoId: string
  agrupamentoDestinoId?: string
  numeroChamadoNovoAgrupamento?: string
}

export interface MoverItemAgrupamentoResponse {
  aviso?: string
}

export type ModoMoverItemAgrupamento = 'novo' | 'existente'

export function montarMoverItemAgrupamentoRequest(
  modo: ModoMoverItemAgrupamento,
  prestadorRecebimentoDocumentoId: string,
  numeroChamadoNovo: string,
  agrupamentoDestinoId: string | null,
): MoverItemAgrupamentoRequest {
  if (modo === 'novo') return { prestadorRecebimentoDocumentoId, numeroChamadoNovoAgrupamento: numeroChamadoNovo }

  return { prestadorRecebimentoDocumentoId, agrupamentoDestinoId: agrupamentoDestinoId || undefined }
}
